import { render, staticRenderFns } from "./WorkplaceRequirements.vue?vue&type=template&id=ca7b8c40"
import script from "./WorkplaceRequirements.js?vue&type=script&lang=js&external"
export * from "./WorkplaceRequirements.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports